import { fromJS } from 'immutable'
import {
  EFFICIENCY_LOB_GET_REQUEST,
  EFFICIENCY_LOB_GET_SUCCESS,
  EFFICIENCY_LOB_GET_FAILURE,
  EFFICIENCY_LOB_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EFFICIENCY_LOB_GET_REQUEST:
      return state
        .set('isFetching', true)
    case EFFICIENCY_LOB_GET_SUCCESS:
      return state
        .set('efficiencyResource', fromJS(action.payload))
        .set('status', action.payload.ok)
        .set('isFetching', false)
    case EFFICIENCY_LOB_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case EFFICIENCY_LOB_GET_RESET:
      return state
        .delete('efficiencyResource')
        .delete('status')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/efficiency-resource/efficiency-lob-get-reducer.js